import React from 'react';
import Card from './Card';

const ForgeInfo = ({ platform, username, url, icon }) => (
    <Card icon={icon} url={url}>
        <div>
            <p><strong>{platform}</strong></p>
            <p><strong>Username: </strong>{username}</p>
        </div>
    </Card>
);

export default ForgeInfo;